<template>
  <div class="mobile-home">
    <!-- 左侧菜单抽屉 -->
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      size="80%"
      :with-header="false"
      class="mobile-drawer"
    >
      <div class="drawer-content">
        <div class="drawer-header">
          <div class="drawer-logo">
            <img src="@/assets/logo/logo.png" alt="克里特·易康" class="logo-img">
            <div class="logo-text">克里特·易康</div>
          </div>
          <el-button class="close-btn" @click="drawerVisible = false" icon="el-icon-close"></el-button>
        </div>
        
        <div class="drawer-menu">
          <div 
            v-for="(item, index) in menuItems" 
            :key="index" 
            class="menu-item"
            :class="{ active: activeMenu === item.path }"
            @click="navigateTo(item.path)"
          >
            {{ item.name }}
          </div>
        </div>
        
        <div class="drawer-footer">
          <div class="contact-info">
            <i class="el-icon-phone"></i>
            咨询：180-2666-8608
          </div>
          <el-button type="primary" size="small" class="login-btn">登录诊所</el-button>
        </div>
      </div>
    </el-drawer>
    
    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 顶部导航栏 -->
      <div class="top-nav">
        <div class="nav-title">
          <img src="@/assets/logo/logo.png" alt="克里特·易康" class="nav-logo">
          <span class="nav-text">克里特·易康</span>
        </div>
        <div class="menu-btn" @click="drawerVisible = true">
          <img style="height: 24px;" src="@/assets/汉堡包.png" alt="克里特·易康" class="nav-logo">
        </div>
      </div>
      
      <!-- 页面内容 -->
      <div class="content">
        <!-- 使用 router-view 显示子路由内容 -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHome',
  data() {
    return {
      drawerVisible: false,
      activeMenu: '/mobile',
      menuItems: [
        { name: '首页', path: '/mobile/home' },
        { name: '产品介绍', path: '/mobile/productIntroduction' },
        { name: '服务与支持', path: '/mobile/serviceSupport' },
        { name: '关于我们', path: '/mobile/aboutUs' }
      ]
    }
  },
  methods: {
    navigateTo(path) {
      this.drawerVisible = false;
      if (path.startsWith('/pc')) {
        // 如果是PC端路径，需要跳转到PC端
        this.$router.push(path);
      } else {
        // 移动端路径直接跳转
        this.$router.push(path);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-home {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #fff;
  min-height: 100vh;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}

// 抽屉样式
.mobile-drawer {
  :deep(.el-drawer__body) {
    padding: 0;
  }
  
  .drawer-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, rgb(206, 204, 252) 0%, #fff8f2 30%, #fff8f2 100%); // 改为官网背景色
    color: #333;
    font-size: 16px;
  }
  
  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #eee;
    
    .drawer-logo {
      display: flex;
      align-items: center;
      gap: 8px;
      
      .logo-img {
        height: 32px;
      }
      
      .logo-text {
        font-size: 18px;
        font-weight: 500;
        color: #333;
      }
    }
    
    .close-btn {
      background: transparent;
      border: none;
      color: #409EFF;
      font-size: 20px;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  .drawer-menu {
    flex: 1;
    padding: 12px 0;
    overflow-y: auto;
    
    .menu-item {
      padding: 15px 16px;
      font-size: 16px;
      font-weight: 400;
      color: #333;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      
      &:hover, &.active {
        color: #333;
        background: #f5f5f5;
        
        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 4px;
          background: #4e78ff;
        }
      }
    }
  }
  
  .drawer-footer {
    padding: 16px;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    gap: 12px;
    
    .contact-info {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #666;
    }
    
    .login-btn {
      background: #4e78ff;
      border: none;
      padding: 12px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 4px;
    }
  }
}

// 主要内容区域
.main-content {
  min-height: 100vh;
  background: linear-gradient(135deg, rgb(206, 204, 252) 0%, #fff8f2 30%, #fff8f2 100%);
}

// 顶部导航栏 - 参考百度移动端风格
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  height: 48px;
  
  .nav-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    color: #333;
    
    .nav-logo {
      height: 24px;
      margin-right: 8px;
    }
    
    .nav-text {
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }
  }
  
  .menu-btn {
    font-size: 20px;
    color: #666;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}


</style>